type RendererConfig = {
    isRenderer: boolean;
    versionNumber: string;
    pushNotificationVapidPublicKey?: string;
}

const getRenderConfig = (): RendererConfig => require('../apphive.config.json') // eslint-disable-line

export default getRenderConfig
